// extracted by mini-css-extract-plugin
export var bullet = "_s5-q";
export var bulletText = "_s5-p";
export var bullets = "_s5-k";
export var callout = "_s5-g";
export var calloutBody = "_s5-i";
export var calloutLabel = "_s5-h";
export var checkIcon = "_s5-m";
export var checkList = "_s5-j";
export var checkSvg = "_s5-n";
export var checkText = "_s5-o";
export var fieldCard = "_s5-1";
export var fieldDescription = "_s5-5";
export var fieldHeader = "_s5-3";
export var fieldTitle = "_s5-4";
export var finalNote = "_s5-s";
export var flow = "_s5-x";
export var flowArrow = "_s5-v";
export var flowStep = "_s5-u";
export var helperText = "_s5-r";
export var inlineTitle = "_s5-t";
export var listItem = "_s5-l";
export var noteBody = "_s5-8";
export var noteBodyText = "_s5-9";
export var noteCard = "_s5-2";
export var noteIcon = "_s5-6";
export var noteTitle = "_s5-7";
export var productChoices = "_s5-w";
export var radioDot = "_s5-d";
export var radioDotSelected = "_s5-e";
export var radioDotSvg = "_s5-f";
export var selectableCard = "_s5-b";
export var selectableCardSelected = "_s5-c";
export var strongText = "_s5-a";
export var subHeading = "_s5-0";